!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("react"), require("prop-types"), require("react-dom"));else if ("function" == typeof define && define.amd) define(["react", "prop-types", "react-dom"], e);else {
    var n = "object" == typeof exports ? e(require("react"), require("prop-types"), require("react-dom")) : e(t.react, t["prop-types"], t["react-dom"]);

    for (var r in n) {
      ("object" == typeof exports ? exports : t)[r] = n[r];
    }
  }
}(global, function (t, e, n) {
  return function () {
    var r = {
      228: function _(t) {
        t.exports = function (t, e) {
          (null == e || e > t.length) && (e = t.length);

          for (var n = 0, r = new Array(e); n < e; n++) {
            r[n] = t[n];
          }

          return r;
        }, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      858: function _(t) {
        t.exports = function (t) {
          if (Array.isArray(t)) return t;
        }, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      713: function _(t) {
        t.exports = function (t, e, n) {
          return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = n, t;
        }, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      884: function _(t) {
        t.exports = function (t, e) {
          var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

          if (null != n) {
            var r,
                o,
                i = [],
                a = !0,
                s = !1;

            try {
              for (n = n.call(t); !(a = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0) {
                ;
              }
            } catch (t) {
              s = !0, o = t;
            } finally {
              try {
                a || null == n.return || n.return();
              } finally {
                if (s) throw o;
              }
            }

            return i;
          }
        }, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      521: function _(t) {
        t.exports = function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      38: function _(t, e, n) {
        var r = n(858),
            o = n(884),
            i = n(379),
            a = n(521);
        t.exports = function (t, e) {
          return r(t) || o(t, e) || i(t, e) || a();
        }, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      379: function _(t, e, n) {
        var r = n(228);
        t.exports = function (t, e) {
          if (t) {
            if ("string" == typeof t) return r(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(t, e) : void 0;
          }
        }, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      99: function _(t) {
        "use strict";

        t.exports = e;
      },
      156: function _(e) {
        "use strict";

        e.exports = t;
      },
      111: function _(t) {
        "use strict";

        t.exports = n;
      }
    },
        o = {};

    function i(t) {
      var e = o[t];
      if (void 0 !== e) return e.exports;
      var n = o[t] = {
        exports: {}
      };
      return r[t](n, n.exports, i), n.exports;
    }

    i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return i.d(e, {
        a: e
      }), e;
    }, i.d = function (t, e) {
      for (var n in e) {
        i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, {
          enumerable: !0,
          get: e[n]
        });
      }
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var a = {};
    return function () {
      "use strict";

      i.r(a), i.d(a, {
        default: function _default() {
          return C;
        }
      });
      var t = i(713),
          e = i.n(t),
          n = i(156),
          r = i.n(n),
          o = i(99),
          s = i.n(o);

      function u(t, e) {
        return u = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, u(t, e);
      }

      var c = i(111),
          p = i.n(c);
      var l = r().createContext(null);

      var f = "unmounted",
          d = "exited",
          m = "entering",
          x = "entered",
          y = "exiting",
          h = function (t) {
        var e, n;

        function o(e, n) {
          var r;
          r = t.call(this, e, n) || this;
          var o,
              i = n && !n.isMounting ? e.enter : e.appear;
          return r.appearStatus = null, e.in ? i ? (o = d, r.appearStatus = m) : o = x : o = e.unmountOnExit || e.mountOnEnter ? f : d, r.state = {
            status: o
          }, r.nextCallback = null, r;
        }

        n = t, (e = o).prototype = Object.create(n.prototype), e.prototype.constructor = e, u(e, n), o.getDerivedStateFromProps = function (t, e) {
          return t.in && e.status === f ? {
            status: d
          } : null;
        };
        var i = o.prototype;
        return i.componentDidMount = function () {
          this.updateStatus(!0, this.appearStatus);
        }, i.componentDidUpdate = function (t) {
          var e = null;

          if (t !== this.props) {
            var n = this.state.status;
            this.props.in ? n !== m && n !== x && (e = m) : n !== m && n !== x || (e = y);
          }

          this.updateStatus(!1, e);
        }, i.componentWillUnmount = function () {
          this.cancelNextCallback();
        }, i.getTimeouts = function () {
          var t,
              e,
              n,
              r = this.props.timeout;
          return t = e = n = r, null != r && "number" != typeof r && (t = r.exit, e = r.enter, n = void 0 !== r.appear ? r.appear : e), {
            exit: t,
            enter: e,
            appear: n
          };
        }, i.updateStatus = function (t, e) {
          void 0 === t && (t = !1), null !== e ? (this.cancelNextCallback(), e === m ? this.performEnter(t) : this.performExit()) : this.props.unmountOnExit && this.state.status === d && this.setState({
            status: f
          });
        }, i.performEnter = function (t) {
          var e = this,
              n = this.props.enter,
              r = this.context ? this.context.isMounting : t,
              o = this.props.nodeRef ? [r] : [p().findDOMNode(this), r],
              i = o[0],
              a = o[1],
              s = this.getTimeouts(),
              u = r ? s.appear : s.enter;
          t || n ? (this.props.onEnter(i, a), this.safeSetState({
            status: m
          }, function () {
            e.props.onEntering(i, a), e.onTransitionEnd(u, function () {
              e.safeSetState({
                status: x
              }, function () {
                e.props.onEntered(i, a);
              });
            });
          })) : this.safeSetState({
            status: x
          }, function () {
            e.props.onEntered(i);
          });
        }, i.performExit = function () {
          var t = this,
              e = this.props.exit,
              n = this.getTimeouts(),
              r = this.props.nodeRef ? void 0 : p().findDOMNode(this);
          e ? (this.props.onExit(r), this.safeSetState({
            status: y
          }, function () {
            t.props.onExiting(r), t.onTransitionEnd(n.exit, function () {
              t.safeSetState({
                status: d
              }, function () {
                t.props.onExited(r);
              });
            });
          })) : this.safeSetState({
            status: d
          }, function () {
            t.props.onExited(r);
          });
        }, i.cancelNextCallback = function () {
          null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
        }, i.safeSetState = function (t, e) {
          e = this.setNextCallback(e), this.setState(t, e);
        }, i.setNextCallback = function (t) {
          var e = this,
              n = !0;
          return this.nextCallback = function (r) {
            n && (n = !1, e.nextCallback = null, t(r));
          }, this.nextCallback.cancel = function () {
            n = !1;
          }, this.nextCallback;
        }, i.onTransitionEnd = function (t, e) {
          this.setNextCallback(e);
          var n = this.props.nodeRef ? this.props.nodeRef.current : p().findDOMNode(this),
              r = null == t && !this.props.addEndListener;

          if (n && !r) {
            if (this.props.addEndListener) {
              var o = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback],
                  i = o[0],
                  a = o[1];
              this.props.addEndListener(i, a);
            }

            null != t && setTimeout(this.nextCallback, t);
          } else setTimeout(this.nextCallback, 0);
        }, i.render = function () {
          var t = this.state.status;
          if (t === f) return null;
          var e = this.props,
              n = e.children,
              o = (e.in, e.mountOnEnter, e.unmountOnExit, e.appear, e.enter, e.exit, e.timeout, e.addEndListener, e.onEnter, e.onEntering, e.onEntered, e.onExit, e.onExiting, e.onExited, e.nodeRef, function (t, e) {
            if (null == t) return {};
            var n,
                r,
                o = {},
                i = Object.keys(t);

            for (r = 0; r < i.length; r++) {
              n = i[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
            }

            return o;
          }(e, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]));
          return r().createElement(l.Provider, {
            value: null
          }, "function" == typeof n ? n(t, o) : r().cloneElement(r().Children.only(n), o));
        }, o;
      }(r().Component);

      function E() {}

      h.contextType = l, h.propTypes = {}, h.defaultProps = {
        in: !1,
        mountOnEnter: !1,
        unmountOnExit: !1,
        appear: !1,
        enter: !0,
        exit: !0,
        onEnter: E,
        onEntering: E,
        onEntered: E,
        onExit: E,
        onExiting: E,
        onExited: E
      }, h.UNMOUNTED = f, h.EXITED = d, h.ENTERING = m, h.ENTERED = x, h.EXITING = y;
      var b = h;
      var v = i(38),
          g = i.n(v);

      function O(t, e) {
        var n = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function S(t) {
        for (var n = 1; n < arguments.length; n++) {
          var r = null != arguments[n] ? arguments[n] : {};
          n % 2 ? O(Object(r), !0).forEach(function (n) {
            e()(t, n, r[n]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : O(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      var T = function T(t) {
        var e = t.content,
            o = t.time,
            i = t.startDelay,
            a = t.transitionTime,
            s = function (t) {
          var e = t.duration;
          return {
            "fade-default": {
              transition: "opacity ".concat(e, "ms ease-in"),
              opacity: 0
            },
            "fade-entering": {
              opacity: 0
            },
            "fade-entered": {
              opacity: 1
            },
            "fade-exiting": {
              opacity: 0
            },
            "fade-exited": {
              opacity: 0
            },
            "zoom-default": {
              transition: "transform ".concat(e, "ms ease-in"),
              transform: "scale(0)",
              opacity: 0
            },
            "zoom-entering": {
              transform: "scale(0)",
              opacity: 0
            },
            "zoom-entered": {
              transform: "scale(1)",
              opacity: 1
            },
            "zoom-exiting": {
              transform: "scale(0)",
              opacity: 1
            },
            "zoom-exited": {
              transform: "scale(0)",
              opacity: 0
            },
            "squeeze-default": {
              transition: "transform ".concat(e, "ms ease-in"),
              transform: "rotateY(90deg)",
              opacity: 0
            },
            "squeeze-entering": {
              transform: "rotateY(90deg)",
              opacity: 0
            },
            "squeeze-entered": {
              transform: "rotateY(0deg)",
              opacity: 1
            },
            "squeeze-exiting": {
              transform: "rotateY(90deg)",
              opacity: 1
            },
            "squeeze-exited": {
              transform: "rotateY(90deg)",
              opacity: 0
            }
          };
        }({
          duration: a
        }),
            u = function (t) {
          var e,
              r,
              o,
              i = t.content,
              a = t.transitionTime,
              s = t.startDelay,
              u = t.time,
              c = (0, n.useRef)(0),
              p = (0, n.useState)(!1),
              l = g()(p, 2),
              f = l[0],
              d = l[1];
          (0, n.useEffect)(function () {
            return r = setTimeout(function () {
              m(), e = setInterval(m, u + 2 * a);
            }, s), function () {
              return clearTimeout(r) && clearInterval(e) && clearTimeout(o);
            };
          }, [i]);
          var m = (0, n.useCallback)(function () {
            var t = c.current,
                e = i[t];
            c.current = e ? t : 0, d(!0), o = setTimeout(function () {
              d(!1), c.current = c.current + 1;
            }, u);
          }, [i]),
              x = i[c.current];
          return {
            isEntered: f,
            indexRef: c,
            currentItemContent: x
          };
        }({
          content: e,
          transitionTime: a,
          startDelay: i,
          time: o
        }),
            c = u.isEntered,
            p = u.indexRef,
            l = u.currentItemContent,
            f = l || {},
            d = f.className,
            m = void 0 === d ? "" : d,
            x = f.animation,
            y = void 0 === x ? "fade" : x,
            h = f.text,
            E = f.link;

        return r().createElement(b, {
          in: c,
          timeout: a
        }, function (t) {
          if (!l || !h) return r().createElement(r().Fragment, null);
          var e = S(S({}, s["".concat(y, "-default")]), s["".concat(y, "-").concat(t)]);
          return r().createElement("div", {
            key: p,
            className: m,
            style: e
          }, E ? r().createElement("a", {
            href: E
          }, h) : h);
        });
      },
          j = s().shape({
        text: s().string.isRequired,
        className: s().string,
        animation: s().string,
        link: s().string
      });

      T.propTypes = {
        time: s().number,
        startDelay: s().number,
        transitionTime: s().number,
        content: s().arrayOf(j).isRequired
      }, T.defaultProps = {
        time: 2500,
        startDelay: 250,
        transitionTime: 500
      };
      var C = T;
    }(), a;
  }();
});